import React from 'react';
import Shape from './utils/shape';
import { default as __ } from '../utils';

function Title({
  label,
  vertices,
  value,
  raw,
  xs = false,
  fill = 'var(--black)',
}) {
  let highlight = value || raw;

  let isLandscape = __.useMediaQuery('(orientation: landscape)');

  return (
    <div
      className="col-center align-center"
      style={{
        fontSize: '0.9rem',
        letterSpacing: '0.05rem',
        textTransform: 'uppercase',
        fontWeight: 600,
        textAlign: 'center',
        color: 'var(--purple)',
      }}
    >
      <Shape.Base
        size={xs ? 240 : isLandscape ? 400 : 240}
        vertices={vertices}
        fill={fill}
      >
        <p className="txt-xl">{__.zeroPad(highlight, 2)}</p>
        <p className="txt-l">{label}</p>
      </Shape.Base>
    </div>
  );
}

export default Title;
